module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAIVBMVEVHcEwAeNoAd9oAeNkAeNoAeOIAdNsAeNsAd9sAd9oAd9qWtA1+AAAACnRSTlMAVudJNwgRd4KLyaWu3AAAALJJREFUKM9jYIADI2UGbEBrEVbhVasoEWYLwCrctRCbMNuqVQJYhFm1Vi3EZogURDm6MOMqsHIM70CUY3geqHwJNp9IrVqOTZgRu2oGDwcG+gGjVUCgjCoA5GqBhJG9rQXm4hDGYQjtgTs0qFhKsAasFyQRoEdDFSQRoEea1yok5YgohiYCjAQhhVCOnHwQylETm9SqRQFYkiZQeQJE+SyUhCy1EmuyZ02gZpbCn12R0zcAq/JaWMuwt1EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/Loading@2x.png
// module id = at9y
// module chunks = 69